export enum EDatePickerExtends {
    today = 'Hoje',
    lastTwoDays = 'Últimos 2 dias',
    lastSevenDays = 'Últimos 7 dias',
    lastFifTeenDays = 'Últimos 15 dias',
    lastThirdyDays = 'Últimos 30 dias',
}

export type EnumTypeDatePickerExtends = typeof EDatePickerExtends;

export type EnumKeyTypeDatePickerExtends = keyof EnumTypeDatePickerExtends;

export function getPropertyNamesFromDatePickerExtends(): string[] {
    return Object.getOwnPropertyNames(EDatePickerExtends);
}
